import {AnyEvent, JOB_VARIATION_ITEM_DELETED, JobVariationItemDeletedEvent} from '../type';

export default function jobVariationItemDeleted(payload: JobVariationItemDeletedEvent['payload']): AnyEvent {
  return {
    type: JOB_VARIATION_ITEM_DELETED,
    payload,
  }
}